import { combineReducers } from "redux"
import { UtilsReducer } from "./utils.reducer"
import { AuthReducer } from "./auth.reducer"
import { MeetingReducer } from "./meeting.reducer"


const Reducer = combineReducers({
    utils: UtilsReducer,
    auth: AuthReducer,
    meeting:MeetingReducer
})

export default Reducer